/* eslint-disable */
import styles from './index.module.scss'
import { Button, FormButton } from '../../components/core/button'
import StepLine from '../../components/core/stepLine'
import { GeneralInput } from '../../components/core/input'
import { Module } from '../../components/core/module'
import { useState, useRef, useEffect, useContext } from 'react'
import { Account, LangArrows, Map, WorkPlace } from '../../icons'
import { PageContext } from '../../context/PageContextProvider'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'
import SelectsAPI from '../../api/selects'

const GetService = ({ className }) => {
  const { language } = useContext(PageContext)
  const checkRef = useRef(null)
  const [verify, setVerify] = useState(null)
  const [error, setError] = useState(null)
  const [checked, setChecked] = useState(false)
  const defaultCriteria = [
    {
      AZ: 'Mikro sahibkarlıq subyekti',
      ENG: 'Micro business entity',
      RU: 'Субъект микропредпринимательства',
    },
    {
      AZ: 'Kiçik sahibkarlıq subyekti',
      ENG: 'Small business entity',
      RU: 'Субъект малого предпринимательства',
    },
    {
      AZ: 'Orta sahibkarlıq subyekti',
      ENG: 'Medium business entity',
      RU: 'Субъект среднего предпринимательства',
    },
    {
      AZ: 'İri sahibkarlıq subyekti',
      ENG: 'Large business entity',
      RU: 'Субъект крупного предпринимательства',
    },
  ]

  const legalForms = [
    {
      AZ: 'Fiziki şəxs (Fərdi Sahibkar)',
      ENG: 'Individual Entrepreneur',
      RU: 'Физическое лицо (ИП)',
    },
    {
      AZ: 'Məhdud Məsuliyyətli Cəmiyyət (MMC)',
      ENG: 'Limited Liability Company (LLC)',
      RU: 'Общество с ограниченной ответственностью (ООО)',
    },
    {
      AZ: 'Açıq Səhmdar Cəmiyyəti (ASC)',
      ENG: 'Open Joint Stock Company (OJSC)',
      RU: 'Открытое акционерное общество (ОАО)',
    },
    {
      AZ: 'Qapalı Səhmdar Cəmiyyəti (QSC)',
      ENG: 'Closed Joint Stock Company (CJSC)',
      RU: 'Закрытое акционерное общество (ЗАО)',
    },
    {
      AZ: 'Xarici hüquqi şəxsin filial / nümayəndəliyi',
      ENG: 'Branch / Representative office of foreign entity',
      RU: 'Филиал / представительство иностранного юр. лица',
    },
    {
      AZ: 'Digər hüquqi şəxs / QHT',
      ENG: 'Other legal entity / NGO',
      RU: 'Другое юридическое лицо / НПО',
    },
  ]

  const employeeCounts = [
    {
      AZ: '1 – 10 nəfər',
      ENG: '1 – 10 employees',
      RU: '1 – 10 человек',
    },
    {
      AZ: '11 – 50 nəfər',
      ENG: '11 – 50 employees',
      RU: '11 – 50 человек',
    },
    {
      AZ: '51 – 250 nəfər',
      ENG: '51 – 250 employees',
      RU: '51 – 250 человек',
    },
    {
      AZ: '251 və daha çox',
      ENG: '251+ employees',
      RU: '251 и более человек',
    },
  ]

  const [data, setData] = useState(defaultCriteria)
  const [load, setLoad] = useState(true)

  const getLocalizedText = (item) => {
    if (!item) return ''
    if (typeof item === 'string') return item
    return item[language] || item.AZ || item.ENG || item.RU || item.title || item.name || ''
  }

  useEffect(() => {
    (async () => {
      try {
        const res = await SelectsAPI.getEntrepreneurship()
        if (Array.isArray(res?.data) && res.data.length > 0) {
          const valid = res.data.filter(
            (item) => item && (item.AZ || item.ENG || item.RU || typeof item === 'string')
          )
          if (valid.length > 0) {
            setData(valid)
          }
        }
      } catch (e) {
        console.warn('Using default entrepreneurship criteria')
      }
    })()
  }, [])
  const [isVisible7, setIsVisible7] = useState(false)
  const [criteria, setCriteria] = useState(translate.choose[language])
  const [isVisibleLegalForm, setIsVisibleLegalForm] = useState(false)
  const [legalForm, setLegalForm] = useState(translate.choose[language])
  const [isVisibleEmployeeCount, setIsVisibleEmployeeCount] = useState(false)
  const [employeeCount, setEmployeeCount] = useState(translate.choose[language])

  useEffect(() => {
    setCriteria(translate.choose[language])
    setLegalForm(translate.choose[language])
    setEmployeeCount(translate.choose[language])
  }, [language])
  const steps = [
    {
      title: translate.add_info,
      text: translate.add_address,
    },
    {
      title: translate.select_service,
      text: translate.select_service_text,
    },
    {
      title: translate.finish,
      text: translate.finish_text,
    },
  ]
  const sendAppeal = () => {
    const fullname = document.querySelector('#service-fullname')?.value.trim()
    if (fullname === '') {
      alert(translate.alert[language])
      return
    }
    const birth = document.querySelector('#service-birth')?.value.trim()
    if (birth === '') {
      alert(translate.alert[language])
      return
    }
    const phone1 = document.querySelector('#service-phone1')?.value.trim() || ''
    if (phone1 === '') {
      alert(translate.alert[language])
      return
    }
    if (
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone1,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone2 = document.querySelector('#service-phone2')?.value.trim() || ''
    if (
      phone2 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone2,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const email = document.querySelector('#service-email')?.value.trim()
    if (email === '') {
      alert(translate.alert[language])
      return
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(translate.alert_email[language])
      return
    }
    const factual = document.querySelector('#service-factual')?.value.trim()
    if (factual === '') {
      alert(translate.alert[language])
      return
    }
    const legal = document.querySelector('#service-legal')?.value.trim()
    if (legal === '') {
      alert(translate.alert[language])
      return
    }
    const voen = document.querySelector('#service-voen')?.value.trim()
    if (voen === '') {
      alert(translate.alert[language])
      return
    }
    const code = document.querySelector('#service-activity-code')?.value.trim()
    if (code === '') {
      alert(translate.alert[language])
      return
    }
    const experience = document
      .querySelector('#service-experience')
      ?.value.trim()
    if (experience === '') {
      alert(translate.alert[language])
      return
    }
    const factual_country = document
      .querySelector('#service-factual-country')
      ?.value.trim()
    if (factual_country === '') {
      alert(translate.alert[language])
      return
    }
    const factual_city = document
      .querySelector('#service-factual-city')
      ?.value.trim()
    if (factual_city === '') {
      alert(translate.alert[language])
      return
    }
    const factual_address = document
      .querySelector('#service-factual-address')
      ?.value.trim()
    if (factual_address === '') {
      alert(translate.alert[language])
      return
    }
    const legal_country = checked
      ? factual_country
      : document.querySelector('#service-legal-country')?.value.trim()
    if (legal_country === '') {
      alert(translate.alert[language])
      return
    }
    const legal_city = checked
      ? factual_city
      : document.querySelector('#service-legal-city')?.value.trim()
    if (legal_city === '') {
      alert(translate.alert[language])
      return
    }
    const legal_address = checked
      ? factual_address
      : document.querySelector('#service-legal-address')?.value.trim()
    if (legal_address === '') {
      alert(translate.alert[language])
      return
    }
    const note = document.querySelector('#service-note')?.value.trim()
    if (
      criteria === translate.choose['AZ'] ||
      criteria === translate.choose['ENG'] ||
      criteria === translate.choose['RU']
    ) {
      alert(translate.alert[language])
      return
    }
    const data = {
      fullname,
      birth,
      phone1,
      phone2,
      email,
      workPlace: {
        factualWorkplace: factual,
        legalWorkplace: legal,
        entrepreneurshipCriteria: criteria,
        legalForm: legalForm === translate.choose[language] ? '' : legalForm,
        employeeCount: employeeCount === translate.choose[language] ? '' : employeeCount,
        voen: voen,
        activityCode: code,
        experience_of_company: experience,
        factualAddress: `${factual_country}, ${factual_city}, ${factual_address}`,
        legalAddress: `${legal_country}, ${legal_city}, ${legal_address}`,
      },
      note,
      options: [],
    }
    sessionStorage.setItem('service', JSON.stringify(data))
    window.location.href = '/get-service2'
  }
  return load ? (
    <>
      <section className={`${className} ${styles.container}`}>
        <StepLine active={0} data={steps} />
        <div className={`${styles.content}`}>
          <h2>
            <Account /> {translate.about_you[language]}
          </h2>
          <div className={styles.about}>
            <GeneralInput
              label={translate.fullname[language]}
              placeholder={translate.enter_name[language]}
              type="text"
              id="service-fullname"
            />
            <GeneralInput
              label={translate.birth[language]}
              type="date"
              id="service-birth"
            />
          </div>
          <div className={styles.gender}>
            <GeneralInput
              label={translate.phone_primary[language]}
              placeholder={'+994'}
              type="text"
              id="service-phone1"
            />
            <GeneralInput
              label={translate.phone_secondary[language]}
              placeholder={'+994'}
              type="text"
              id="service-phone2"
            />
          </div>
          <div className={styles.email}>
            <GeneralInput
              label={translate.email[language]}
              placeholder={translate.enter_email[language]}
              type="email"
              id="service-email"
              onBlur={(e) => {
                setError(
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    e.target.value,
                  ),
                )
              }}
            />
          </div>
          <h2>
            <WorkPlace /> {translate.about_work[language]}
          </h2>
          <div className={styles.work}>
            <GeneralInput
              label={translate.factual[language]}
              id="service-factual"
              type="text"
              placeholder={translate.enter_name[language]}
            />
            <GeneralInput
              label={translate.legal[language]}
              id="service-legal"
              type="text"
              placeholder={translate.enter_name[language]}
            />
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisible7(false)
                }, 250)
              }
            >
              <p>{translate.entrepreneurship[language]}</p>
              <span tabIndex="1" onClick={() => setIsVisible7(true)}>
                {criteria} <LangArrows />
              </span>
              <ul
                style={isVisible7 ? { display: 'block' } : { display: 'none' }}
              >
                {data && data.filter(Boolean).map((e, idx) => {
                  const text = getLocalizedText(e)
                  if (!text) return null
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setCriteria(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisibleLegalForm(false)
                }, 250)
              }
            >
              <p>{language === 'AZ' ? 'Təşkilati-Hüquqi forması' : language === 'TR' ? 'Hukuki Yapı / Şirket Türü' : language === 'RU' ? 'Организационно-правовая форма' : 'Legal & Organizational Form'}</p>
              <span tabIndex="1" onClick={() => setIsVisibleLegalForm(true)}>
                {legalForm} <LangArrows />
              </span>
              <ul
                style={isVisibleLegalForm ? { display: 'block' } : { display: 'none' }}
              >
                {legalForms.map((e, idx) => {
                  const text = getLocalizedText(e)
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setLegalForm(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisibleEmployeeCount(false)
                }, 250)
              }
            >
              <p>{language === 'AZ' ? 'İşçi sayı' : language === 'TR' ? 'Çalışan Sayısı' : language === 'RU' ? 'Количество сотрудников' : 'Number of Employees'}</p>
              <span tabIndex="1" onClick={() => setIsVisibleEmployeeCount(true)}>
                {employeeCount} <LangArrows />
              </span>
              <ul
                style={isVisibleEmployeeCount ? { display: 'block' } : { display: 'none' }}
              >
                {employeeCounts.map((e, idx) => {
                  const text = getLocalizedText(e)
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setEmployeeCount(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <GeneralInput
              label={translate.voen[language]}
              type="text"
              placeholder={translate.enter_code[language]}
              id="service-voen"
            />
            <GeneralInput
              label={translate.activity_code[language]}
              type="text"
              placeholder={translate.enter_info[language]}
              id="service-activity-code"
            />
            <GeneralInput
              label={translate.experience_company[language]}
              type="date"
              id="service-experience"
            />
          </div>
          <h2>
            <Map /> {translate.workplace[language]}
          </h2>
          <div className={styles.address}>
            <p>{translate.factual_address[language]}</p>
            <div>
              <GeneralInput
                label={translate.country[language]}
                type="text"
                id="service-factual-country"
                placeholder={translate.enter_info[language]}
              />
              <GeneralInput
                label={translate.city[language]}
                type="text"
                placeholder={translate.enter_info[language]}
                id="service-factual-city"
              />
              <GeneralInput
                label={translate.address[language]}
                type="text"
                id="service-factual-address"
                placeholder={translate.enter_info[language]}
              />
            </div>
            <label>
              <input
                onClick={() => {
                  setChecked(!checked)
                }}
                checked={checked}
                type="checkbox"
                ref={checkRef}
              />
              {translate.same_address[language]}
            </label>
            {!checked && <p>{translate.legal_address[language]}</p>}
            {!checked && (
              <div>
                <GeneralInput
                  label={translate.country[language]}
                  type="text"
                  id="service-legal-country"
                  placeholder={translate.enter_info[language]}
                />
                <GeneralInput
                  label={translate.city[language]}
                  type="text"
                  id="service-legal-city"
                  placeholder={translate.enter_info[language]}
                />
                <GeneralInput
                  label={translate.address[language]}
                  type="text"
                  id="service-legal-address"
                  placeholder={translate.enter_info[language]}
                />
              </div>
            )}
          </div>
          <div className={styles.textarea}>
            <p>{translate.note[language]}</p>
            <span>{translate.not_required[language]}</span>
            <textarea
              id="service-note"
              placeholder={translate.write_note[language]}
            ></textarea>
          </div>
          <FormButton onClick={() => sendAppeal()}>
            {translate.save_next[language]}
          </FormButton>
        </div>
      </section>
    </>
  ) : (
    <Loading />
  )
}

export default GetService
